/// <amd-module name="typeahead/core/logging/SelectionToSubmissionLogger" />

import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {SelectionToSubmissionMetric} from "typeahead/core/logging/SelectionToSubmissionMetric";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class SelectionToSubmissionLogger {

    private lob: string;
    private domElementId: string;
    private suggestionSelectedTimestamp: number;
    private submitClickedTimestamp: number;
    private activeESSTests: string = "";

    constructor() {
        // Suggestions displayed
        TypeaheadMessage.subscribe(
            SuggestionShownMessage.getTopic(), (topic: string, message: SuggestionShownMessage) => {
                this.activeESSTests = message.getActiveESSTests();
            },
        );

        // Suggestion selected
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, message: SuggestionSelectedMessage) => {
                this.domElementId = message.getDomElementId();
                this.lob = message.getLob();
                this.suggestionSelectedTimestamp = Date.now();
            },
        );

        // Wizard submitted
        TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(), () => {
                if (this.domElementId) {
                    this.submitClickedTimestamp = Date.now();
                    this.emitSelectionToSubmissionMetric();

                    // reset logger state
                    this.domElementId = undefined;
                    this.lob = undefined;
                    this.suggestionSelectedTimestamp = 0;
                    this.submitClickedTimestamp = 0;
                }
            },
        );
    }

    private emitSelectionToSubmissionMetric(): void {
        new CollectorTransport().log(new SelectionToSubmissionMetric(
            this.lob,
            this.domElementId,
            this.suggestionSelectedTimestamp,
            this.submitClickedTimestamp,
            this.activeESSTests), "typeahead_client_metrics");
    }
}
